import { memo } from 'react';
import { AiChatBody } from './AiChatBody';
import { AiViewportWrapper } from './AiViewportWrapper';
import { MessageGroupSkeleton } from './MessageGroupSkeleton';

export const AiChatSkeleton = memo(() => (
	<AiChatBody>
		<AiViewportWrapper>
			<MessageGroupSkeleton />
		</AiViewportWrapper>
	</AiChatBody>
));
